import { Outlet } from 'react-router-dom';

export const PayrollOutlet = () => <Outlet />;
